import { render, staticRenderFns } from "./IconHaircut.vue?vue&type=template&id=cb48ac1a&"
import script from "./IconHaircut.vue?vue&type=script&lang=js&"
export * from "./IconHaircut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports